export const state = () => ({
	all_schools: [],
	school: null,
	current_step: 1,
	has_school_type: false,
});

export const mutations = {
	setAllSchools(state: any, payload: any) {
		state.all_schools = payload;
	},
	setSchool(state: any, payload: any) {
		state.school = payload;
	},
	setHasSchoolType(state: any, payload: any) {
		state.has_school_type = payload;
	},
	setCurrentStep(state: any, payload: any) {
		state.current_step = payload;
	},
};

export const getters = {
	getAllSchools: (state: any) => state.all_schools,
	getSchool: (state: any) => state.school,
	getHasSchoolType: (state: any) => state.has_school_type,
	getCurrentStep: (state: any) => state.current_step,
};

export const actions = {
	async getAllSchools(state: any, payload: any) {
		if (!(state.state.all_schools.length > 0)) {
			return new Promise((resolve, reject) => {
				this.$axios
					.get('/api/profile/schools')
					.then((res) => {
						state.commit('setAllSchools', res.data);
						resolve(res);
					})
					.catch((err) => {
						reject(err);
					});
			});
		} else {
			return new Promise((resolve, reject) => {
				resolve(state.state.all_schools);
			});
		}
	},

	async getSchool(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.get('/api/profile/schools/' + payload)
				.then((res) => {
					state.commit('setSchool', res.data);
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async createSchool(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.post('/api/profile/schools', payload)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async editSchool(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.put('/api/profile/schools/' + payload.uuid, payload.data)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async deleteSchool(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.delete('/api/profile/schools/' + payload)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async createDocument(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.post(
					'/api/profile/schools/' + payload.uuid + '/documents',
					payload.data,
				)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	updateAllSchools(state: any, payload: any) {
		state.commit('setAllSchools', payload);
	},

	updateSchool(state: any, payload: any) {
		state.commit('setSchool', payload);
	},

	updateHasSchoolType(state: any, payload: any) {
		state.commit('setHasSchoolType', payload);
	},

	updateCurrentStep(state: any, payload: any) {
		state.commit('setCurrentStep', payload);
	},
};
